import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.rating >= 9).slice(0, 6);
  const latest = [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, 6);

  return (
    <>
      <section className="py-10 md:py-14 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-end justify-between mb-6 md:mb-8">
            <div>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                高分伦理剧推荐
              </h2>
              <p className="text-sm text-foreground-600 mt-1">
                精心挑选的高口碑伦理剧作品
              </p>
            </div>
            <a
              href="/category/jingdian-lunli"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
            >
              查看全部 <i className="ri-arrow-right-line ml-1"></i>
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {featured.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 bg-background-100/70">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-end justify-between mb-6 md:mb-8">
            <div>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                最新伦理剧解析
              </h2>
              <p className="text-sm text-foreground-600 mt-1">
                及时更新的深度剧情解读与推荐
              </p>
            </div>
            <a
              href="/category/guochan-lunli"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
            >
              更多文章 <i className="ri-arrow-right-line ml-1"></i>
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {latest.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}